import React from "react";
import "./sidebar.css";
import logo from "../../assets/images/logo.png";
import sidebar_items from "../../assets/JsonData/sidebar_routes.json";
import sidebar_validator_items from "../../assets/JsonData/sidebar_routes_is_validator.json";
import SubMenu from "./SubMenu";
import useUserRole from "../../hooks/useUserRole";
import packageJson from "../../../package.json";

const Sidebar = (props) => {
  const { isValidator } = useUserRole();
  const version = packageJson.version;

  const activeItem = isValidator
    ? sidebar_validator_items.findIndex(
        (item) => item.route === props?.location?.pathname
      )
    : sidebar_items.findIndex(
        (item) => item.route === props?.location?.pathname
      );

  return (
    <div className="sidebar">
      <div className="sidebar__top">
        <div className="sidebar__logo">
          <img src={logo} alt="company logo" />
        </div>
        {isValidator
          ? sidebar_validator_items.map((item, index) => (
              <div key={index}>
                <SubMenu
                  item={item}
                  key={index}
                  active={index === activeItem}
                />
              </div>
            ))
          : sidebar_items.map((item, index) => (
              <div key={index}>
                <SubMenu
                  item={item}
                  key={index}
                  active={index === activeItem}
                />
              </div>
            ))}
      </div>

      <div className="sidebar__bottom">
        <span>Version : {version}</span>
      </div>
    </div>
  );
};

export default Sidebar;
